import { useEffect } from 'react';
import DrawerAlerts from 'Components/alerts/components/DrawerAlerts';
import BackIcon from 'Components/common/assets/svgIcons/BackIcon';
import DISCSmall from 'Components/common/assets/svgIcons/DISCSmall';
import GlobalSearch from 'Components/globalSearch/components/GlobalSearch';
import NavBarPrimary from 'Components/layout/headers/NavBarPrimary';
import FeedTabs from 'Components/common/tabs/Tabs';
import MotivatorTab from 'Components/arctypes/components/MotivatorTab';
import PersuaderTab from 'Components/arctypes/components/PersuaderTab';
import PromoterTab from 'Components/arctypes/components/PromoterTab';
import CollaboratorTab from 'Components/arctypes/components/CollaboratorTab';
import AdvocateTab from 'Components/arctypes/components/AdvocateTab';
import ProponentTab from 'Components/arctypes/components/ProponentTab';
import CoordinatorTab from 'Components/arctypes/components/CoordinatorTab';
import EqualizerTab from 'Components/arctypes/components/EqualizerTab';
import ManagerTab from 'Components/arctypes/components/ManagerTab';
import StrategistTab from 'Components/arctypes/components/StrategistTab';
import ChallengerTab from 'Components/arctypes/components/ChallengerTab';
import InvestigatorTab from 'Components/arctypes/components/InvestigatorTab';
import DesignerTab from 'Components/arctypes/components/DesignerTab';
import LeaderTab from 'Components/arctypes/components/LeaderTab';
import DriverTab from 'Components/arctypes/components/DriverTab';
import CreatorTab from 'Components/arctypes/components/CreatorTab';

import styled from 'styled-components';
import { useNavigate, useParams } from 'react-router-dom';
import AccountPopOver from 'Components/common/components/AccountPopOver';
import { isGuest } from 'Utils/UtilityFunctions';
import {
  wLight, secondaryFont,
  primaryHeadingColor,
  primaryFont, wMedium, persuader,
  motivator, promoter,
  collaborator, advocate, proponent,
  coordinator, equalizer, manager,
  strategist, challenger, investigator,
  designer, leader, driver, creator,
} from '../../Utils/utilsStyle';

const Wrapper = styled.div`
  .header-wrapper {
    .left-side-wrap {
      .heading {
        margin-top: -2px;
        svg {
          height: 25px;
          vertical-align: bottom;
        }
      }
    }
  }
  .sub-heading{
    font-size:24px;
    color:${primaryHeadingColor};
    font-family:${primaryFont};
    font-weight:${wMedium};
    margin-bottom:15px;
  }
  .recomended-users{
    padding:0 10px;
    a{
      color:#FF7439;
      font-size:14px;
      font-family:${secondaryFont};
      font-weight:${wLight};
      float: right;
      svg{
        margin-left: 10px;
        vertical-align: middle;
      }
    }
  }
  .drivers-list{
    .tag-p{
      margin:0;
      min-height:auto;
    }
  }
  .tabs-wrapper{
    flex-wrap: wrap;
    margin-bottom:14px;
    justify-content: space-around;
    a{
      margin-bottom:16px;
      margin-right:0;
      border-radius:22px;
      min-width: 12%;
      width: 12%;
      text-align:center;
      color:#fff;
      border:none;
      font-family:${secondaryFont};
      font-weight:${wLight};
      @media all and  (max-width: 1230px){
        padding: 7px 20px;
        min-width: 11%;
        width: 11%;
      }
      &:nth-child(1){
        background-color: ${persuader};
      }
      &:nth-child(2){
        background-color: ${motivator};
      }
      &:nth-child(3){
        background-color: ${promoter};
      }
      &:nth-child(4){
        background-color: ${collaborator};
      }
      &:nth-child(5){
        background-color: ${advocate};
      }
      &:nth-child(6){
        background-color: ${proponent};
      }
      &:nth-child(7){
        background-color: ${coordinator};
      }
      &:nth-child(8){
        background-color: ${equalizer};
      }
      &:nth-child(9){
        background-color: ${manager};
      }
      &:nth-child(10){
        background-color: ${strategist};
      }
      &:nth-child(11){
        background-color: ${challenger}
      }
      &:nth-child(12){
        background-color: ${investigator};
      }
      &:nth-child(13){
        background-color: ${designer};
      }
      &:nth-child(14){
        background-color: ${leader};
      }
      &:nth-child(15){
        background-color: ${driver};
      }
      &:nth-child(16){
        background-color: ${creator};
      }
    }
  }
`;

type TabsInterface = {
  [key: string]: JSX.Element
};

const ArcTypes = function ArcTypes() {
  const { section } = useParams();
  const navigate = useNavigate();
  const tabs: TabsInterface = {
    persuader: <PersuaderTab />,
    motivator: <MotivatorTab />,
    promoter: <PromoterTab />,
    collaborator: <CollaboratorTab />,
    advocate: <AdvocateTab />,
    proponent: <ProponentTab />,
    coordinator: <CoordinatorTab />,
    equalizer: <EqualizerTab />,
    manager: <ManagerTab />,
    strategist: <StrategistTab />,
    challenger: <ChallengerTab />,
    investigator: <InvestigatorTab />,
    designer: <DesignerTab />,
    leader: <LeaderTab />,
    driver: <DriverTab />,
    creator: <CreatorTab />,
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Wrapper>
      <NavBarPrimary>
        <div className="left-side-wrap">
          <BackIcon onClick={() => navigate(-1)} />
          <h1 className="heading">
            <DISCSmall />
            {' '}
            DISC Personality Explorer
          </h1>
        </div>
        {!isGuest() && (
          <div className="right-side-wrap">
            <GlobalSearch />
            <DrawerAlerts />
            <AccountPopOver />
          </div>
        )}
      </NavBarPrimary>
      <div className="container arctypes-container-style">
        <FeedTabs baseComponentPath="arctypes" tabsName={['Persuader', 'Motivator', 'Promoter', 'Collaborator', 'Advocate', 'Proponent', 'Coordinator', 'Equalizer', 'Manager', 'Strategist', 'Challenger', 'Investigator', 'Designer', 'Leader', 'Driver', 'Creator']} headerAppendTab elementTarget="tabs-details" />
        {tabs[section || 'persuader']}
      </div>
    </Wrapper>
  );
};

export default ArcTypes;
